import axios from "axios";
import qs from "qs";
import {
  BASIC_DASHBOARD_STATS,
  DATA_DASHBOARD_STOCK_ALERT,
  DATA_DASHBOARD_STATS,
  AI_DASHBOARD,
  NOTIFICATION_URL,
  STOCK_REORDER,
  STOCK_REORDER_DETAILS,
  READ_ALL_NOTIFICATIONS_URL,
  GET_ALL_REMINDERS_URL,
  REMINDER_URL,
  DASHBOARD_AGING_INVOICES
} from "../../../../../constants/config";

export function getDashboardStats(params) {
  return axios.get(`${BASIC_DASHBOARD_STATS}`, { params });
}

export function getDashboardStockAlerts(newParams) {
  return axios.get(`${DATA_DASHBOARD_STOCK_ALERT}`, { params: newParams });
}
export function stockreorder(params) {
  return axios.get(`${STOCK_REORDER}`, { params });
}
export function stockReorderDeatils(params) {
  return axios.get(`${STOCK_REORDER_DETAILS}`, { params });
}
export function getAgingData(params) {
  return axios.get(`${DASHBOARD_AGING_INVOICES}`, {
    params,
    paramsSerializer: (queryParams) =>
      qs.stringify({
        ...queryParams,
        overdue_period: queryParams.overdue_period?.join(","),
      }),
  });
}
export function getDateDependDashboardStats(params) {
  return axios.get(`${DATA_DASHBOARD_STATS}`, { params });
}

export function getAiDashboard(params) {
  return axios.get(`${AI_DASHBOARD}`, { params });
}

export function getNotifications(params) {
  return axios.get(`${NOTIFICATION_URL}/list`, { params });
}
export function updateNotifications({ id, is_viewed }) {
  return axios.patch(`${NOTIFICATION_URL}/${id}`, { is_viewed });
}


// Read All Notification 
export function readAllNotifications(params) {
  return axios.patch(`${READ_ALL_NOTIFICATIONS_URL}`, params);
}

// Reminders
export const getAllReminders= ()=>{
  return axios.get(GET_ALL_REMINDERS_URL);
}

export const getReminderById= (id)=>{
  return axios.get(`${REMINDER_URL}/${id}`);
}

export const createNewReminder =(payload)=>{
  return axios.post(REMINDER_URL, payload)
}

export const deleteReminderById=(id)=>{
  return axios.delete(`${REMINDER_URL}/${id}`)
}

export const updateReminderById=(id, payload)=>{
  return axios.put(`${REMINDER_URL}/${id}`, payload)
}
